export default __webpack_public_path__ + "static/media/NewOverview.00c24fdb.svg";